export class StoreSelector extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.optionsHtml = ''
  }

  connectedCallback () {
    super.connectedCallback()

    /* Force redirect - Start */
    if (window.location.href.indexOf('#geo') > -1) {
      return this.forceRedirect()
    }
    /* Force redirect - End */

    /* ?country= in URL check - Start */
    // eslint-disable-next-line compat/compat
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
    this.countryParam = params.country

    if (this.countryParam !== null) {
      this.setStorageFromURL(this.countryParam)
    }
    /* ?country= in URL check - End */

    if (this.countryParam !== null) {
      const countryCode = this.countryParam

      this.setupCountrySwitcherModal(countryCode)
      this.updateShippingLabel(countryCode)
    } else if (!this.noLocationStored) {
      const countryCode = window.localStorage.getItem(this.userLocationName)

      this.setupCountrySwitcherModal(countryCode)
      this.updateShippingLabel(countryCode)
    } else {
      window.BAO.Utils.fetchJSON('/browsing_context_suggestions.json', {
        method: 'GET',
      }).then(res => {
        const countryCode = res.detected_values.country.handle

        this.setupCountrySwitcherModal(countryCode)
        this.updateShippingLabel(countryCode)
      })
    }

    this.setupListeners()
  }

  forceRedirect () {
    window.BAO.Utils.fetchJSON('/browsing_context_suggestions.json', {
      method: 'GET',
    }).then(res => {
      const userCountry = res.detected_values.country.handle

      let windowPathname = window.location.pathname

      const subdomainFolder = windowPathname.split('/').filter(item => {
        return item.indexOf('en-') > -1
      })

      if (subdomainFolder) {
        windowPathname = windowPathname
          .replace(subdomainFolder, '')
          .replace('//', '/')
      }

      window.location.href = `${
        this.sites[this.countries[userCountry].site].url
      }${windowPathname}?country=${userCountry}`
    })
  }

  setupListeners () {
    super.setupListeners()

    this.onOptionClick = this.onOptionClick.bind(this)
    this.onConfirmClick = this.onConfirmClick.bind(this)
    this.onTriggerClick = this.onTriggerClick.bind(this)

    if (this.els?.options?.exists) {
      this.els.options.elements.forEach(optionEl => {
        this.listeners.add(optionEl, 'change', this.onOptionClick)
      })
    }

    if (this.els?.confirm?.exists) {
      this.els.confirm.elements.forEach(confirmEl => {
        this.listeners.add(confirmEl, 'click', this.onConfirmClick)
      })
    }

    if (this.externalEls?.trigger?.exists) {
      this.externalEls.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, 'click', this.onTriggerClick)
      })
    }

    /* Added due to trigger in mobile menu being rendered after page load */
    document.addEventListener('click', e => {
      if (e?.target?.dataset?.storeSelectorExternalEl === 'trigger') {
        this.onTriggerClick()
      }
    })
  }

  setStorageFromURL (countryCode) {
    if (this.countries[countryCode].site === this.dataset.store) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }
  }

  onTriggerClick () {
    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')
  }

  onOptionClick (e) {
    const selectedOptionValue = e.currentTarget.value
    const selectedOptionCode =
      e.currentTarget.options[e.currentTarget.selectedIndex].dataset.code
    const selectedOptionCurrency =
      e.currentTarget.options[e.currentTarget.selectedIndex].dataset.currency

    this.els.flag.element.src = `https://cdn.shopify.com/s/files/1/0749/4500/3816/files/flag-${selectedOptionCode}.svg`

    this.els.confirm.elements.forEach(confirmEl => {
      confirmEl.dataset.url = this.sites[selectedOptionValue].url
      confirmEl.dataset.code = selectedOptionCode
      confirmEl.dataset.currency = selectedOptionCurrency
    })
  }

  onConfirmClick (event) {
    event.preventDefault()

    let windowPathname = window.location.pathname

    const subdomainFolder = windowPathname.split('/').filter(item => {
      return item.indexOf('en-') > -1
    })

    if (subdomainFolder) {
      windowPathname = windowPathname
        .replace(subdomainFolder, '')
        .replace('//', '/')
    }

    if (
      this.countries[event.currentTarget.dataset.code].site ===
      this.dataset.store
    ) {
      window.localStorage.setItem(
        this.userLocationName,
        event.currentTarget.dataset.code,
      )

      this.els['localisation-select'].element.value =
        event.currentTarget.dataset.code
      this.els['localisation-select'].element.dispatchEvent(new Event('change'))
    } else if (event.currentTarget.hasAttribute('data-url')) {
      window.location.href = `${event.currentTarget.dataset.url}${windowPathname}?country=${event.currentTarget.dataset.code}`
    }
  }

  updateShippingLabel (countryCode) {
    if (this.noLocationStored) return

    const upperCountryCode = countryCode.toUpperCase()

    if (this.externalEls?.flag?.exists) {
      this.externalEls.flag.elements.forEach(flagExternalEl => {
        flagExternalEl.src = `https://cdn.shopify.com/s/files/1/0749/4500/3816/files/flag-${upperCountryCode}.svg`
      })
    }

    /* Added due to trigger in mobile menu being rendered after page load */
    window.setTimeout(() => {
      document
        .querySelectorAll('[data-store-selector-external-el="flag"]')
        .forEach(el => {
          el.src = `https://cdn.shopify.com/s/files/1/0749/4500/3816/files/flag-${upperCountryCode}.svg`
        })
    }, 1000)

    if (this.countries[upperCountryCode] !== undefined) {
      const name = this.countries[upperCountryCode].name

      if (this.externalEls?.country?.exists) {
        this.externalEls.country.elements.forEach(countryExternalEl => {
          countryExternalEl.innerHTML = `${name}`
        })
      }

      /* Added due to trigger in mobile menu being rendered after page load */
      window.setTimeout(() => {
        document
          .querySelectorAll('[data-store-selector-external-el="country"]')
          .forEach(el => {
            el.innerHTML = `${name}`
          })
      }, 1000)
    }

    if (this.externalEls?.trigger?.exists) {
      this.externalEls.trigger.elements.forEach(triggerExternalEl => {
        triggerExternalEl.style.opacity = 1
      })
    }
  }

  setupCountrySwitcherModal (countryCode) {
    this.createOptionsList(countryCode)
    this.setDefaultConfirmButtonURL()

    this.els.flag.element.src = `https://cdn.shopify.com/s/files/1/0749/4500/3816/files/flag-${countryCode}.svg`
    window.setTimeout(() => {
      this.els.flag.element.src = `https://cdn.shopify.com/s/files/1/0749/4500/3816/files/flag-${countryCode}.svg`
    }, 500)

    if (
      this.countries[countryCode].site === this.dataset.store &&
      this.dataset.store === 'UK'
    ) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }

    if (!this.noLocationStored) return

    if (this.countryParam !== null) return

    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')
  }

  createOptionsList (countryCode) {
    Object.entries(this.countries).forEach(([key, value]) => {
      const { name, site, currency } = value
      const isCurrentSite = key.toLowerCase() === countryCode.toLowerCase()
      this.optionsHtml += this.createOptionElement(
        key,
        site,
        isCurrentSite,
        name,
        currency,
      )
    })

    this.els.options.element.innerHTML = this.optionsHtml
  }

  createOptionElement (code, site, isCurrentSite, country, currency) {
    return `<option
      data-code="${code}"
      data-currency="${currency}"
      value="${site}"
      ${isCurrentSite ? 'selected' : ''}
    >
      ${country} (${currency})
    </option>`
  }

  setDefaultConfirmButtonURL () {
    const selectedOptionValue = this.els.options.element.value
    const selectedOptionCode = this.els.options.element.options[
      this.els.options.element.selectedIndex
    ].dataset.code
    const selectedOptionCurrency = this.els.options.element.options[
      this.els.options.element.selectedIndex
    ].dataset.currency

    this.els.confirm.elements.forEach(confirmEl => {
      confirmEl.dataset.url = this.sites[selectedOptionValue].url
      confirmEl.dataset.code = selectedOptionCode
      confirmEl.dataset.currency = selectedOptionCurrency
    })
  }

  get noLocationStored () {
    return (
      window.localStorage.getItem(this.userLocationName) == null ||
      (window.localStorage.getItem(this.userLocationName) === undefined &&
        !window.Shopify.designMode)
    )
  }

  get userLocationName () {
    return 'BAO-localization'
  }

  get sites () {
    return {
      EU: {
        url: 'https://omorovicza.eu',
      },
      UK: {
        url: 'https://omorovicza.co.uk',
      },
      US: {
        url: 'https://omorovicza.com',
      },
    }
  }

  get countries () {
    return window.theme.countries
  }
}

if (!customElements.get('store-selector')) {
  customElements.define('store-selector', StoreSelector)
}
